"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function safeThrow(error) {
    setTimeout(function () {
        throw error;
    }, 0);
}

exports["default"] = safeThrow;
module.exports = exports["default"];